export default "__VITE_ASSET__DADn2bQx__"